import {Emitter} from "./emitter";

export class QuantitySelector extends Emitter {
    constructor(selector) {
        super();
        this.selector = selector;
        this.input = selector.find('input[type="number"]');
        this.product_cart_quantity = ABV4_SETTINGS.cart_quantity_single_max;
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleStepButtonClick = this.handleStepButtonClick.bind(this);
        this.handleStepBundleButtonClick = this.handleStepBundleButtonClick.bind(this);
        selector.on('click', '.step-button', this.handleStepButtonClick);
        selector.on('click', '.step-button-kit', this.handleStepBundleButtonClick)
        this.input.on('change', this.handleInputChange);
    }

    setProductCartQuantity(productHandle) {
        const cartUniqueQuantity = ABV4_SETTINGS.cart_quantity.unique_cart_quantity.unique_quantity;
        const regularQunatityCondition = ABV4_SETTINGS.cart_quantity.cart_quantity_single_max;
        const cartUniqueQuantityConditions = ABV4_SETTINGS.cart_quantity.unique_cart_quantity.conditions_variant;
        let unique = false;
        for(let i = 0; i < cartUniqueQuantityConditions.length; i++) {
            const item = cartUniqueQuantityConditions[i];

            if(productHandle == item) {
                unique = true;
            }
        }

        if(unique) {
            this.product_cart_quantity = cartUniqueQuantity;
        } else {
            this.product_cart_quantity = regularQunatityCondition;
        }
    }

    handleStepBundleButtonClick(e) {
        const
            {selector, input } = this,
            downButton = selector.find('.step-button-kit.down'),
            upButton = selector.find('.step-button-kit.up'),
            button = $(e.target),
            delta = button.hasClass('up') ? 1 : -1,
            newValue = Math.max(1, parseInt(input.val(), 10) + delta);
         input.val(newValue);
        downButton.prop('disabled', newValue === 1);
        let disabledUpButton = false;
        if(newValue >= ABV4_SETTINGS.cart_quantity_bundle_max){
            disabledUpButton = true;
        }
        upButton.prop('disabled', disabledUpButton);
        this.emit('change', newValue);

        e.preventDefault();
        e.stopPropagation();
    }

    handleStepButtonClick(e) {
        const
            {selector, input} = this,
            downButton = selector.find('.step-button.down'),
            upButton = selector.find('.step-button.up'),
            button = $(e.target);
            let disabledDownbutton = 1;
            if($(selector).data('handle')) {
                const handle = selector.data('handle');
                if(doubled_products[handle]) {
                    disabledDownbutton = 1 + doubled_products[handle];
                    var up = 1 + doubled_products[handle],
                        down = -1 - doubled_products[handle];
                } else {
                    var up = 1,
                        down = -1;
                }
            } else {
                var up = 1,
                down = -1;
            }

            const delta = button.hasClass('up') ? up : down,
            newValue = Math.max(1, parseInt(input.val(), 10) + delta);
        input.val(newValue);
        let disabledUpButton = false;
        if(newValue >= this.product_cart_quantity){
            disabledUpButton = true;
        }

        upButton.prop('disabled', disabledUpButton);
        downButton.prop('disabled', newValue === disabledDownbutton);
        this.emit('change', newValue);

        e.preventDefault();
        e.stopPropagation();

    }

    handleInputChange(e) {
        const newValue = this.input.val();
        this.emit('change', newValue);
    }

    value() {
        return parseInt(this.input.val(), 10);
    }

    setValue(value) {
        value = Math.max(1, value);
        this.input.val(value);
        return this;
    }

    reset(handle = null) {

        if(handle === null) {
            return this.setValue(1);
        } else {
            if(doubled_products[handle]) {
                const newValue = 1 + doubled_products[handle];
                return this.setValue(newValue);
            } else {
                return this.setValue(1);
            }
        }
    }

    stepupReset() {
       const {selector, input} = this,
        upButton = selector.find('.step-button.up').prop('disabled', false);
    }

    enable(enabled) {
        const {selector, input} = this;
        selector.toggleClass('disabled', !enabled);
        input.toggleClass('disabled', !enabled).prop('disabled', !enabled);
        return this;
    }
}
